/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import startCase from 'lodash/startCase';
// import { superAdminHomeRoute } from '../../config/navigation/routes';
// import { forwardTo } from '../../utils/browserHistoryUtils';
import {
  organizationInDB as requestOrg,
  getOrgByID,
} from '../../../graphql/organizationDetails';
// import history from '../../../config/history';

import { UpdateOrganization } from '../../../graphql/organization';
import { requestUserByEmail } from '../../../graphql/users';
import { createUser as createUserQuery } from '../../../graphql/updateUsers';
import { requestBidMatchingSettings } from '../../../pages/SolicitationsSearch/graphql';

export default function EditOrganizationHOC(EditOrganizationPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        jwtToken: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
        role: PropTypes.string,
      }).isRequired,
      selectedOrganizationId: PropTypes.string.isRequired,
      showEditModal: PropTypes.bool.isRequired,
      closeEditModal: PropTypes.func.isRequired,
      refreshOrganizations: PropTypes.func.isRequired,
    };

    static initialState = {
      isLoading: true,
      initialValues: {
        admins: [{ name: '', email: '' }],
        matchSettingList: {
          methods: [''],
          materials: [''],
          minimumEstimatedCost: 0,
          minimumQuantity: 0,
        },
      },
      errors: [],
      alerts: [], // updates to UI Alerts should be objects
      userMessage: '',
      messages: [],
    };

    state = WrappedComponent.initialState;

    async componentDidMount() {
      // const id = window.location.pathname.split(
      //   '/superadmin/edit/organization/',
      // )[1];
      this._getInitialValues(this.props.selectedOrganizationId);
    }

    _getInitialValues = async id => {
      const { organization } = await getOrgByID(id);
      const requestedSettings = await requestBidMatchingSettings(id);
      if (requestedSettings.organization.matchSettingList === null)
        requestedSettings.organization.matchSettingList = [];
      // if (organization.cageCode.startsWith("OG")) {
      //   const newUsers = [];
      //   for (let i = 0; i <= organization.users.length; i++) {
      //     if (organization.users[i].email === organization.email) {
      //       newUsers.push(organization.users[i]);
      //       break;
      //     }
      //   }
      //   organization.users = newUsers;
      // }
      const initialValues = {
        ...organization,
        ...requestedSettings.organization,
      };
      this.setState({
        initialValues,  // to be used for reset button
        formValues: initialValues
      });
    };

    onResetForm = () => {
      // this.setState(prevState => ({
      //   formValues: {
      //     ...prevState.initialValues,
      //   }
      // }))
      this.setState({
        formValues: this.state.initialValues
      });
    }

    onCountryChange = (value) => {
      this.setState(prevState => ({
        formValues: {
          ...prevState.formValues,
          cntry: value,
          state: null,
        }
      }))
    }

    onStateProvChange = (value) => {
      this.setState(prevState => ({
        formValues: {
          ...prevState.formValues,
          state: value,
        }
      }))
    }

    onFieldChange = (name, value) => {
      if (name === "cntry" || name === "state") {
        return
      }
      this.setState(prevState => ({
        formValues: {
          ...prevState.formValues,
          [name]: value,
        }
      }))
    }

    _transformMatchSettings = (matchSettingsList = []) => {
      const formattedSettings = matchSettingsList.map(ms => {
        // Todo: #Brian do better
        const materials =
          ms.materials && ms.materials.length !== 0
            ? ms.materials.map(mat => startCase(mat))
            : [];
        const methods =
          ms.methods && ms.methods.length !== 0
            ? ms.methods.map(met => startCase(met))
            : [];
        const minimumQuantity = ms.minimumQuantity
          ? parseFloat(ms.minimumQuantity)
          : 0;
        const minimumEstimatedCost = ms.minimumEstimatedCost
          ? parseFloat(ms.minimumEstimatedCost)
          : 0;
        return {
          materials,
          methods,
          minimumQuantity,
          minimumEstimatedCost,
        };
      });
      return formattedSettings[0];
      // - ... but it works
    };
    // _transformMatchSettings = matchSettings => {
    //   const materials = matchSettings.materials
    //     ? matchSettings.materials.map(mat => startCase(mat))
    //     : [];
    //   const methods = matchSettings.methods
    //     ? matchSettings.methods.map(met => startCase(met))
    //     : [];
    //   const minimumQuantity = parseFloat(matchSettings.minimumQuantity) || 0;
    //   const minimumEstimatedCost =
    //     parseFloat(matchSettings.minimumEstimatedCost) || 0;

    //   return [
    //     {
    //       materials,
    //       methods,
    //       minimumQuantity,
    //       minimumEstimatedCost,
    //     },
    //   ];
    // };

    // IE should be adjusted catch and display error
    _UpdateOrganizationSuccessDialogue = () => {
      const newmessage = [...this.state.messages];
      this.setState({
        messages: [
          ...newmessage,
          {
            alertType: 'success',
            alertMessage: 'Organization updated!',
          },
        ],
      });
    };

    _UpdateOrganizationErrorDialogue = () => {
      const newmessage = [...this.state.messages];
      this.setState({
        messages: [
          ...newmessage,
          {
            alertType: 'warning',
            alertMessage: 'Unable to update organization!',
          },
        ],
      });
    };

    _UpdateuserSuccessDialogue = () => {
      const newmessage = [...this.state.messages];
      this.setState({
        messages: [
          ...newmessage,
          {
            alertType: 'success',
            alertMessage: 'User updated!',
          },
        ],
      });
    };

    _AllUsersBlockedSuccessDialogue = () => {
      const newmessage = [...this.state.messages];
      this.setState({
        messages: [
          ...newmessage,
          {
            alertType: 'success',
            alertMessage: 'All users belonging to this organization have been blocked!',
          },
        ],
      });
    };

    _UpdateUserErrorDialogue = () => {
      const newmessage = [...this.state.messages];
      this.setState({
        messages: [
          ...newmessage,
          {
            alertType: 'warning',
            alertMessage: 'Unable to update user!',
          },
        ],
      });
    };

    _UpdateMatchSettingsSuccessDialogue = () => {
      const newmessage = [...this.state.messages];
      this.setState({
        messages: [
          ...newmessage,
          {
            alertType: 'success',
            alertMessage: 'Bid Match settings updated!',
          },
        ],
      });
    };

    _UpdateMatchSettingsErrorDialogue = () => {
      const newmessage = [...this.state.messages];
      this.setState({
        messages: [
          ...newmessage,
          {
            alertType: 'warning',
            alertMessage: 'Unable to update Bid Match settings!',
          },
        ],
      });
    };

    _onSubmit = async formData => {
      this.setState({ messages: [] });

      const {
        pointOfContact,
        phoneNumber,
        email,

        address1,
        address2,
        address3,
        zipCode,
        cntry,
        cageCode,
        city,
        name,
        state,
        organizationType,
        websiteUrl,
        iconStatus,
      } = formData;

      const orgInformation = {
        address1,
        address2,
        address3,
        zipCode,
        cntry,
        cageCode,
        city,
        name,
        state,
        organizationType,
        websiteUrl,
        iconStatus,
        pointOfContact,
        phoneNumber,
        email,
      };

      const { organizationInDB } = await requestOrg(cageCode);
      const { userByEmail } = await requestUserByEmail(email);
      const organizationId = organizationInDB.id;
      const payLoad = { ...orgInformation, id: organizationId };
      let userInfo = {};

      if (!userByEmail) {
        // This CREATES a user in BOTH Auth0 and DynamoDB
        userInfo = {
          name: pointOfContact,
          email,
          phoneNumber,
          organizationId,
          role: 'admin',
          iconStatus,
          cageCode,
        };
      } else {
        // This UPDATES a user in DynamoDB and CREATES them in Auth0
        userInfo = {
          id: userByEmail.id,
          auth0Id: userByEmail.auth0Id,
          name: pointOfContact,
          phoneNumber,
          email,
          organizationId,
          role: 'admin',
          iconStatus,
          cageCode
        };
      }

      try {
        await UpdateOrganization(payLoad);

        await createUserQuery(userInfo);
        if (iconStatus === 'denied') {
          organizationInDB.users.forEach(user => {
            if (user.id !== userInfo.id) {
              const updatedUser = {
                ...user,
                role: user.role.includes('super')
                  ? 'super'
                  : user.role.includes('admin')
                    ? 'admin'
                    : 'user'
              };
              createUserQuery(updatedUser);
            }
          });
          this._AllUsersBlockedSuccessDialogue();
        }
        this._UpdateOrganizationSuccessDialogue();
        this._UpdateuserSuccessDialogue();


        setTimeout(() => { this.props.closeEditModal(); this.props.refreshOrganizations() }, 2000);
      } catch (error) {
        this._UpdateOrganizationErrorDialogue();
        this._UpdateUserErrorDialogue();
        this._UpdateMatchSettingsErrorDialogue();
        console.error(error);
      }
      return undefined;
    };

    render() {
      const { isLoading, errors, formValues, messages } = this.state;
      const { closeEditModal, showEditModal } = this.props;
      // Configure Page
      const pageProps = {
        isLoading,
        onSubmit: this._onSubmit,
        errors,
        initialValues: formValues,
        messages,
        onCountryChange: this.onCountryChange,
        onStateProvChange: this.onStateProvChange,
        onFieldChange: this.onFieldChange,
        onResetForm: this.onResetForm,
        closeEditModal,
        showEditModal
      };

      return <EditOrganizationPage {...pageProps} />;
    }
  }

  return WrappedComponent;
}



// WEBPACK FOOTER //
// ./src/components/Modals/EditOrganization/EditOrganizationHOC.jsx